import {createSlice, PayloadAction} from "@reduxjs/toolkit";

interface FilterState {
	location: number[];
	startDate: string;
	endDate: string;
	plan: string[];
	dimension: string;
	loader: boolean;
}

const initialState: FilterState = {
	location: [],
	// defaults to the start of the month
	startDate: new Date(Date.now() - (new Date().getDate()) * 24 * 60 * 60 * 1000)
		.toISOString()
		.split("T")[0],
	// defaults to yesterday
	endDate: new Date(new Date().setDate(new Date().getDate() - 1)).toISOString().split("T")[0],
	plan: [
		"Deluxe",
		"Premium",
		"Ultimate",
		"Classic"
	],
	dimension: "",
	loader: false,
};

const filterSlice = createSlice({
	name: "filter",
	initialState,
	reducers: {
		setFilter: (state, action: PayloadAction<FilterState>) => {
			return {...state, ...action.payload};
		},
		resetFilter: () => initialState,
		setFilterLoader: (state, action: PayloadAction<boolean>) => {
			state.loader = action.payload;
		},
	},
});

export const {setFilter, resetFilter, setFilterLoader} = filterSlice.actions;
export default filterSlice.reducer;
